import Card from '../../components/ui/Card'
import Badge from '../../components/ui/Badge'
import Button from '../../components/ui/Button'
import { formatCurrency, formatDate } from '../../lib/format'
import { getInvoiceStatusConfig } from '../../lib/stripe'

function InvoiceList({ invoices, onView, onEdit, onDelete, onSend, onMarkPaid }) {
  if (invoices.length === 0) {
    return (
      <Card className="text-center py-8">
        <p className="text-muted mb-4">No invoices yet</p>
        <p className="text-sm text-muted">Create your first invoice to start tracking revenue</p>
      </Card>
    )
  }

  return (
    <div className="invoice-list">
      <table className="table">
        <thead>
          <tr>
            <th>Invoice #</th>
            <th>Client</th>
            <th>Business</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Due Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map(invoice => {
            const statusConfig = getInvoiceStatusConfig(invoice.status)
            const isOverdue = invoice.status === 'sent' &&
              new Date(invoice.due_date) < new Date()

            return (
              <tr key={invoice.id}>
                <td>
                  <button
                    onClick={() => onView(invoice)}
                    className="text-primary font-medium hover:underline"
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                  >
                    {invoice.invoice_number}
                  </button>
                </td>
                <td>
                  <div>
                    <div className="font-medium">{invoice.clients?.name}</div>
                    {invoice.clients?.company && (
                      <div className="text-sm text-muted">{invoice.clients?.company}</div>
                    )}
                  </div>
                </td>
                <td>
                  {invoice.businesses && (
                    <span>{invoice.businesses.emoji} {invoice.businesses.name}</span>
                  )}
                </td>
                <td className="font-medium">
                  {formatCurrency(invoice.total)}
                </td>
                <td>
                  <Badge variant={isOverdue ? 'archived' : statusConfig.badge}>
                    {isOverdue ? 'Overdue' : statusConfig.label}
                  </Badge>
                </td>
                <td>
                  <span style={{ color: isOverdue ? 'var(--error)' : 'inherit' }}>
                    {formatDate(invoice.due_date)}
                  </span>
                </td>
                <td>
                  <div className="flex gap-2">
                    {invoice.status === 'draft' && (
                      <>
                        <Button size="sm" variant="secondary" onClick={() => onEdit(invoice)}>
                          Edit
                        </Button>
                        <Button size="sm" variant="primary" onClick={() => onSend(invoice.id)}>
                          Send
                        </Button>
                      </>
                    )}
                    {invoice.status === 'sent' && (
                      <Button size="sm" variant="primary" onClick={() => onMarkPaid(invoice.id)}>
                        Mark Paid
                      </Button>
                    )}
                    {['draft', 'sent'].includes(invoice.status) && (
                      <Button size="sm" variant="danger" onClick={() => onDelete(invoice.id)}>
                        Delete
                      </Button>
                    )}
                    {invoice.status === 'paid' && (
                      <span className="text-success text-sm">Paid {formatDate(invoice.paid_at)}</span>
                    )}
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default InvoiceList
